import React from 'react';
import type {
  TaskAssignmentResponse,
  TaskDefinitionResponse,
} from 'src/api/ProactApiClient';
import {ContentBody} from 'src/app/content-pdf/ContentBody';
import {excludeContentFields} from 'src/app/content-pdf/contentPdf';
import {FormViewComponentV2} from 'src/app/forms/FormViewComponent/FormViewComponentV2';
import {DocumentUnderReviewPanel} from 'src/app/tasks/DocumentUnderReviewPanel';
import {Stack} from 'src/design/atoms/Stack';
import {TableBodyRender} from 'src/design/molecules/TableBodyRender';
import {ErrorAlert} from 'src/design/molecules/ErrorAlert';
import {parseErrorMessage} from 'src/shared/utils/parseErrorMessage';
import {toTaskDefinitionFormData} from 'src/app/tasks/taskFeatureTypes';
import {useToolboxTalkFormMeta} from './ToolboxTalkForm';

export const ToolboxTalkDefinitionView: React.FC<{
  item: TaskDefinitionResponse;
}> = ({item}) => {
  const {formMeta, isLoading, error} = useToolboxTalkFormMeta(item.state);
  if (isLoading) return <TableBodyRender isLoading />;
  if (error) return <ErrorAlert message={parseErrorMessage(error)} />;
  const detailsMeta = excludeContentFields(formMeta).filter(
    field =>
      !['subject', 'dueInDays', 'dueAt', 'previewDueAt'].includes(field.name)
  );
  const formData = toTaskDefinitionFormData(item);

  return (
    <Stack gap="md">
      {item.documentId && (
        <DocumentUnderReviewPanel
          documentId={item.documentId}
          documentVersion={item.documentVersion}
        />
      )}
      {detailsMeta.length > 0 && (
        <FormViewComponentV2 formData={formData} formMeta={detailsMeta} />
      )}
      <ContentBody content={item.content} contentPdfUrl={item.contentPdfUrl} />
    </Stack>
  );
};

export const ToolboxTalkAssignmentView: React.FC<{
  item: TaskAssignmentResponse;
}> = ({item}) => (
  <ContentBody
    content={item.taskDefinition.content}
    contentPdfUrl={item.taskDefinition.contentPdfUrl}
  />
);
